<template>
  <div v-if="seconds" class="absolute top-0 left-0 w-100 w-full bg-green-200 h-2.5 mb-4">
    <div class="transition-all ease-linear duration-1000 bg-green-600 h-2.5" :style="progress"></div>
  </div>
</template>

<script>
export default {
  name: 'QuestionTimer',

  props: {
    seconds: Number,
  },
emits: ['timeout'],

  data() {
    return {
      secondsLeft: null,
    }
  },

  computed: {
    progress() {
      let percent = Math.floor( 100 / this.seconds * this.secondsLeft )
      // console.log(percent)
      return `width: ${percent}%`
    },
  },

  mounted() {
    this.secondsLeft = this.seconds
    // if seconds passed, if not, don't start timer
    if( this.seconds ) {
      this.checkIfExceeded()
    }
  },

  methods: {

    checkIfExceeded(){
      if (this.secondsLeft > -1 ) {
        setTimeout(() => {
          this.secondsLeft  -= 1
          this.checkIfExceeded()
        }, 1000 )
      } else {
        this.$emit('timeout', true ) // true means, was missed
      }
    },
  },
}
</script>

<style scoped>

</style>